import React, { createContext, useContext, useState } from 'react';

// Create a Context
const ClientContext = createContext();

// Create a Provider
export const ClientProvider = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState(localStorage.getItem('ScId') || null);

  // Update both state and localStorage
  const updateSelectedClient = (client) => {
    setSelectedClient(client);
    localStorage.setItem('ScId', client);
  };

  return (
    <ClientContext.Provider value={{ selectedClient, updateSelectedClient }}>
      {children}
    </ClientContext.Provider>
  );
};

// Custom Hook to Access Context
export const useClient = () => {
    const context = useContext(ClientContext);
    if (!context) {
      throw new Error("useClient must be used within a ClientProvider");
    }
    return context; // This should return an array
  };
